var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col col-12" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { readonly: "" },
          domProps: { value: _vm.value }
        })
      ]),
      _c("div", { staticClass: "col-md-2 mt-1" }, [
        _c(
          "div",
          { staticClass: "btn-group" },
          [
            _vm.hasPermisionSave
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: "Editar en linea",
                        expression: "'Editar en linea'"
                      }
                    ],
                    staticClass: "btn btn-outline-secondary",
                    on: { click: _vm.openEditHtml }
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("edit")
                    ])
                  ]
                )
              : _vm._e(),
            _c("DownloadS3File", {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: "Descargar",
                  expression: "'Descargar'"
                }
              ],
              attrs: {
                path: _vm.value,
                name: _vm.param + ".html",
                force: "si",
                "style-class": "btn btn-outline-secondary"
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function(props) {
                    return [
                      !props.downloading
                        ? _c("span", { staticClass: "material-icons" }, [
                            _vm._v("cloud_download")
                          ])
                        : _vm._e(),
                      props.downloading
                        ? _c("b-spinner", {
                            attrs: { variant: "primary", size: "18" }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm.hasPermisionSave
              ? _c("UploadFileToS3", {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: "Cargar",
                      expression: "'Cargar'"
                    }
                  ],
                  attrs: {
                    "upload-to": _vm.attachmentUrl,
                    accept: "text/html"
                  },
                  on: { input: _vm.uploadLocalFile },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button",
                        fn: function(props) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { disabled: props.progress.enabled }
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("cloud_upload")
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3294952022
                  )
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "modaleditar",
          attrs: {
            id: "modaleditar",
            title: "Editor online",
            size: "xl",
            "hide-footer": ""
          }
        },
        [
          _vm.loadContent
            ? _c("b-spinner", { attrs: { variant: "primary", size: "18" } })
            : _vm._e(),
          !_vm.loadContent
            ? _c(
                "b-card-text",
                [
                  _c("HtmlPreview", {
                    attrs: { content: _vm.content },
                    on: { input: _vm.input }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.progress.enabled
            ? _c("vs-progress", {
                attrs: {
                  percent: _vm.progress.percent,
                  indeterminate: _vm.progress.indeterminate,
                  color: _vm.color
                }
              })
            : _vm._e(),
          !_vm.loadContent
            ? _c("div", { staticClass: "text-center" }, [
                _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm.changeHtmlEditor } },
                  [_vm._v(" Aceptar ")]
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }